import React from 'react'

import spinner from '../../../assets/images/spinner.gif'

import './spinner.scss'

const Spinner = () => {
  return (
    <div className="w-screen h-screen fixed top-0 left-0 flex justify-center items-center bg-white opacity-75 z-200">
      <img className="indicator" src={spinner} alt="Loading..." />
    </div>
  )
}

export default Spinner
